import { ExecutionDetailMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getExecutionDetailMetrics = async (
  orgId: string,
  labelIds?: string[],
): Promise<ExecutionDetailMetricsResponse> => {
  const params = labelIds?.length
    ? '?' +
      labelIds.map((id) => `label_ids=${encodeURIComponent(id)}`).join('&')
    : '';

  const response = await apiRequest<ExecutionDetailMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/execution-detail${params}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch execution detail metrics');
  }

  return response.data;
};
